export const mockAvaDate = {
    recurred_off_days: [0], // sunday
    off_days: []
}